import axios from 'axios'
import hostConf from '$config/frontend'
import { showNetworkErrorSnackbar } from '$comp/snackbars'
import { getAuthToken } from '$logic/auth'

export const postApi = action =>
  axios
    .post(
      `${hostConf.HTTP_HOST}/api`,
      { action: JSON.stringify(action) },
      {
        headers: {
          ...(getAuthToken() ? { 'X-Auth-Token': getAuthToken() } : null),
        },
      },
    )
    .then(res => res.data)

export const httpRequest = async action => {
  const response = await postApi(action).catch(() => {
    showNetworkErrorSnackbar()
    return false
  })

  return response || false
}

/**
 * Keeps the body and rate-limit metadata of non-2xx responses. Most callers
 * only need `httpRequest`, but auth must be able to distinguish an HTTP 429
 * from a network failure so it can honour the server-provided cooldown.
 */
export const httpRequestWithMetadata = async action => {
  try {
    return { response: (await postApi(action)) || false }
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return {
        response: error.response.data || false,
        status: error.response.status,
        retryAfter: error.response.headers?.['retry-after'],
      }
    }

    showNetworkErrorSnackbar()
    return { response: false }
  }
}
